module.exports = __webpack_public_path__ + "img/timeline-01a.68dc4021.jpg";